import React from "react";
import { Checkbox, TableRow, TableCell, styled } from "@mui/material";
import { InputField } from "../../../../../../components/Form/InputField";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.MuiTableCell-head`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.MuiTableCell-body`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const InvoiceTableRows: React.FC<InvoiceTableRowsProps> = ({
    orderItems,
    values,
    handleChange,
    setFieldValue,
    setFieldTouched,
    selectedRowId,
    setBilledQuantities,
    handleSelectCheck,
}) => {
    if (orderItems.length === 0) {
        return (
            <StyledTableRow>
                <StyledTableCell colSpan={4} align="center">
                    No records found
                </StyledTableCell>
            </StyledTableRow>
        );
    }

    return (
        <>
            {orderItems.map((item: any) => {
                const remainingQty = item.quantity - (item.billed_quantity + item.cancelled_quantity + item.returned_quantity)
                const isDisabled = remainingQty === 0;

                return (
                    !isDisabled &&
                    <StyledTableRow key={item.id}>
                        <StyledTableCell>
                            <Checkbox
                                sx={{ border: "1px solid #000000" }}
                                checked={selectedRowId.includes(item.id)}
                                onClick={() => !isDisabled && handleSelectCheck(item.id)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                            {item.product_name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                            {remainingQty} {`(${item.quantity})`}
                        </StyledTableCell>
                        <StyledTableCell align="left" sx={{ width: "2em" }}>
                            <InputField
                                label=""
                                name={`billed_qty.${item.id}`}
                                placeholder="Enter Process Quantity"
                                value={values.billed_qty?.[item.id]}
                                disabled={isDisabled}
                                onChange={(e) => {
                                    handleChange(e);
                                    const { name, value } = e.target;
                                    const [, id] = name.split(".");
                                    setFieldValue(name, value);
                                    setTimeout(() => {
                                        setFieldTouched(name, true, true);
                                    }, 0);
                                    setBilledQuantities((prev) => ({
                                        ...prev,
                                        [id]: value,
                                    }));
                                }}
                            />
                        </StyledTableCell>
                    </StyledTableRow>
                )
            })}
        </>
    );
};

export default InvoiceTableRows;
